<template>
  <div>
    <template v-if="auth.user.role ==='city' || auth.user.role === 'province'">
      <el-row>
        <el-col :span="12">
          <div class="card">
            <el-card>
              <area-data :key="timer" title="机构数(个)" :labels="labels" :series="series1"></area-data>
            </el-card>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="card">
            <el-card>
              <area-data :key="timer" title="注册资本金(亿元)" :labels="labels" :series="series2"></area-data>
            </el-card>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="card">
            <el-card>
              <area-data :key="timer" title="累放金额(亿元)" :labels="labels" :series="series3"></area-data>
            </el-card>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="card">
            <el-card>
              <area-data :key="timer" title="累放笔数、户数" :labels="labels" :series="series4"></area-data>
            </el-card>
          </div>
        </el-col>
        <el-col :span="12" :xl="6">
          <div class="card">
            <el-card>
              <loan-chart></loan-chart>
            </el-card>
          </div>
        </el-col>
        <el-col :span="12" :xl="6">
          <div class="card">
            <el-card>
              <loan-dist></loan-dist>
            </el-card>
          </div>
        </el-col>
        <el-col :span="24">
          <div class="card">
            <el-card class="h-full report-status">
              <report-status></report-status>
            </el-card>
          </div>

        </el-col>



      </el-row>
    </template>
    <template v-else-if="auth.user.role === 'district'">
      <el-row>
        <el-col :span="24">
          <div class="card">
            <el-card class="h-full report-status">
              <report-status></report-status>
            </el-card>
          </div>

        </el-col>
        <el-col :span="12" :xl="6">
          <div class="card">
            <el-card>
              <loan-dist></loan-dist>
            </el-card>
          </div>
        </el-col>
      </el-row>
    </template>
    <template v-else>
      控制台
    </template>
  </div>
</template>
<script>

import Layout from '@/Shared/Layout2'
import AreaData from '../../components/dashboard/AreaData'
import BriefData from '../../components/dashboard/BriefData'
import LoanChart from '../../components/dashboard/LoanChart'
import LoanDist from '../../components/dashboard/LoanDist'
import ReportStatus from '../../components/dashboard/ReportStatus'
import axios from 'axios'


export default {
  components: {ReportStatus, LoanDist, LoanChart, BriefData, AreaData},
  layout: Layout,

  props: {
    auth: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      timer: Date.now(),
      labels: [],
      series1: [],
      series2: [],
      series3: [],
      series4: [],
      series5: [],
      loading: false,
      name: '',
      id: '',
      editData: {
        /* 需要加载的表单数据可以在这里进行设置 */
      },
    }
  },
  computed: {},
  watch: {},
  created() {
    // this.getFormData();
    if (this.auth.user.role ==='city' || this.auth.user.role === 'province' || this.auth.user.role === window.AREA.DISTRICT) {
      this.getData()
    }
  },
  methods: {
    getData() {
      axios.get('/dashboard/area_data').then(res => {
        if (res.data.status === 1) {
          this.series1 = [{
            name: '机构数',
            type: 'column',
            data: res.data.series.count_series,
          }]
          this.series2 = [{
            name: '注册资本金',
            type: 'column',
            data: res.data.series.capital_series,
          }]
          this.series3 = [{
            name: '累放金额',
            type: 'column',
            data: res.data.series.data17_series,
          }]
          this.series4 = [{
            name: '累放笔数',
            type: 'column',
            data: res.data.series.total_series,
          },{
            name: '累放户数',
            type: 'column',
            data: res.data.series.nums_series,
          }]
          this.labels =  res.data.labels
          this.timer = Date.now()
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.card {
  margin: 10px;
  height: 380px;
}

::v-deep .brief-card .el-card__body {
  height: calc(100% - 53px);
  overflow-y: auto;
}
::v-deep .report-status .el-card__body {
  height: 100%;
}
</style>
